export default "__VITE_ASSET__CcJpL9Zz__"